import { render, staticRenderFns } from "./js-single-dialog.vue?vue&type=template&id=29948f8a&scoped=true"
import script from "./js-single-dialog.vue?vue&type=script&lang=js"
export * from "./js-single-dialog.vue?vue&type=script&lang=js"
import style0 from "./js-single-dialog.vue?vue&type=style&index=0&id=29948f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29948f8a",
  null
  
)

export default component.exports